import { render, staticRenderFns } from "./Sign-up.vue?vue&type=template&id=a131d3d6&scoped=true&"
import script from "./Sign-up.vue?vue&type=script&lang=js&"
export * from "./Sign-up.vue?vue&type=script&lang=js&"
import style0 from "./Sign-up.vue?vue&type=style&index=0&id=a131d3d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a131d3d6",
  null
  
)

export default component.exports